const KeyPrefix = 'LN-';
const ExpirationSuffix = '-Expiration';

const KeyPrefixRegExp = new RegExp(`^${KeyPrefix}(.*)`);

const LNStorage = {
    /**
     * Gets the item associated to the specified key.
     * @param {string} key A unique identifier for the item.
     * @returns {Object} The item if found and has not expired; otherwise, null.
     */
    Get(key) {
        if (_flushExpiredItem(key)) {
            return null;
        }

        const value = _getItem(key);

        try {
            return JSON.parse(value);
        }
        catch (ex)  {
            return value;
        }
    },

    /**
     * Stores an entry with the given key and value.
     * @param {any} key A unique identifier for the item.
     * @param {any} value The value.
     * @param {any} time The expiration time.
     */
    Set(key, value, time) {
        const expirationKey = _getExpirationKey(key);

        try {
            value = JSON.stringify(value);
        }
        catch (ex) {
            return;
        }

        _setItem(key, value);

        if (time) {
            _setItem(expirationKey, (_getCurrentTime() + time).toString());
        }
        else {
            _removeItem(expirationKey);
        }
    },

    /**
     * Removes the item associated to the specified key.
     * @param {string} key A unique identifier for the item.
     */
    Remove(key) {
        _flushItem(key);
    },

    /**
     * Removes all items.
     */
    Flush() {
        const keys = _getKeys();

        keys.forEach((key) => {
            _flushItem(key);
        });
    },

    /**
     * Removes all expired items.
     */
    FlushExpired() {
        const keys = _getKeys();

        keys.forEach((key) => {
            _flushExpiredItem(key);
        });
    }
};

function _getKeys() {
    const keys = [];

    for (let i = 0; i < localStorage.length; i++) {
        let key = localStorage.key(i);

        key = key && key.match(KeyPrefixRegExp);
        key = key && key[1];

        if (_isLNStorageKey(key)) {
            keys.push(key);
        }
    }

    return keys;
}

function _getItem(key) {
    return localStorage.getItem(_getKey(key));
}

function _setItem(key, value) {
    localStorage.setItem(_getKey(key), value);
}

function _removeItem(key) {
    localStorage.removeItem(_getKey(key));
}

function _flushItem(key) {
    const expirationKey = _getExpirationKey(key);

    _removeItem(key);
    _removeItem(expirationKey);
}

function _flushExpiredItem(key) {
    const expirationKey = _getExpirationKey(key);
    const expirationItem = _getItem(expirationKey);

    if (expirationItem) {
        const expirationTime = parseInt(expirationItem);
        
        if (_getCurrentTime() >= expirationTime) {
            _removeItem(key);
            _removeItem(expirationKey);

            return true;
        }
    }
}

function _getKey(key) {
    return KeyPrefix + key;
}

function _getExpirationKey(key) {
    return key + ExpirationSuffix;
}

function _isLNStorageKey(key) {
    return key
        && !key.endsWith(ExpirationSuffix);
}

function _getCurrentTime() {
    return new Date().getTime();
}

export default LNStorage;


// WEBPACK FOOTER //
// ./Statics/scripts/Core/LocalStorage/LNStorage.js